import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MasterRewardCreatePageRoutingModule } from './master-reward-create-routing.module';

import { MasterRewardCreatePage } from './master-reward-create.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MasterRewardCreatePageRoutingModule,
    ReactiveFormsModule,
    IonicSelectableModule
  ],
  declarations: [MasterRewardCreatePage]
})
export class MasterRewardCreatePageModule {}
